import { useEffect, useLayoutEffect, useRef } from 'react'

const useEffectByEnvironment =
  typeof window === 'undefined' ? useEffect : useLayoutEffect

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback)

  useEffectByEnvironment(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (delay === null) {
      return
    }

    const id = setInterval(() => {
      savedCallback.current()
    }, delay)

    return () => {
      clearInterval(id)
    }
  }, [delay])
}
